import React, { useEffect, useState } from "react";
import {
  Col,
  Button,
  Row,
  Card,
  Tabs,
  Tab,
  Alert,
  ButtonGroup,
  Collapse,
} from "react-bootstrap";
//import { LoadingHatch } from "../../components/Loader/Loading";
import GenericTable from "../../components/Table/GenericTable";
import "./Config.css";
import { Link } from "react-router-dom";
import {
  getPrinters,
  insertPrinter,
  deletePrinter,
} from "../../api/printersApi";
import errorAlert from "../errors/errorAlert";
import Swal from "sweetalert2";

const PrinterConfig = () => {
  const [printers, setPrinters] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [accordionKey, setAccordionKey] = useState(0);
  const [reload, setReload] = useState(false);

  const getData = async () => {
    try {
      setIsLoading(true);
      const resp = await getPrinters();
      setPrinters(resp.data);
    } catch (error) {
      errorAlert(error);
    } finally {
      setIsLoading(false);
    }
  };

  const insert = async (data) => {
    try {
      setIsLoading(true);
      const resp = await insertPrinter(data);
      if (resp?.success) {
        Swal.fire({
          title: "Agregada correctamente!",
          icon: "success",
        });
      }
    } catch (error) {
      errorAlert(error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteP = async (id) => {
    try {
      setIsLoading(true);
      const response = await Swal.fire({
        title: "Seguro desea eliminar?",
        showConfirmButton: true,
        confirmButtonText: "Eliminar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        cancelButtonColor: "gray",
        icon: "question",
      });
      if (response.isConfirmed) {
        const resp = await deletePrinter(id);
        if (resp?.success) {
          Swal.fire({
            title: "Eliminada!",
            icon: "success",
          });
          setReload((prev) => !prev);
        }
      }
    } catch (error) {
      errorAlert(error);
    } finally {
      setIsLoading(false);
    }
  };

  const ActionsCell = ({ row }) => {
    return (
      <div>
        <Button
          variant="danger"
          size="sm"
          onClick={() => deleteP(row.original?.id)}
        >
          <i className="feather icon-trash" />
        </Button>
      </div>
    );
  };

  //const estado = (item) => item.id? 'Checked':'No'

  const columns = React.useMemo(
    () => [
      {
        Header: "Tipo",
        accessor: "type",
        filter: "equals",
      },
      {
        Header: "Nombre",
        accessor: "name",
        filter: "fuzzyText",
      },
      {
        Header: "Acciones",
        filter: "",
        Cell: ActionsCell,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    getData();

    // const savedPrinter = localStorage.getItem("selectedPrinter");
    // if (
    //   savedPrinter &&
    //   savedPrinter !== "null" &&
    //   savedPrinter !== "undefined"
    // ) {
    //   setSelectedPrinter(JSON.parse(savedPrinter));
    // }

    //   const savedPrinters = localStorage.getItem("printers");
    //   if (savedPrinters) {
    //     setPrinters(JSON.parse(savedPrinters));
    //   }
  }, [reload]);

  const addUSBPrinter = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const device = await navigator.usb.requestDevice({
        filters: [
          { vendorId: 0x0483 }, // Ajusta según tus necesidades
        ],
      });

      const printerInfo = {
        device_id: device.productId,
        type: "usb",
        name: device.productName,
        manufacturer: device.manufacturerName,
        vendorId: device.vendorId,
        productId: device.productId,
      };

      addPrinterToList(printerInfo);
    } catch (error) {
      console.error("Error al agregar impresora USB:", error);
      setError(
        "No se pudo conectar con la impresora USB. Verifique la conexión."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const addBluetoothPrinter = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const device = await navigator.bluetooth.requestDevice({
        filters: [
          { services: ["000018f0-0000-1000-8000-00805f9b34fb"] }, // Servicio genérico de impresora, ajusta según necesites
        ],
        optionalServices: ["battery_service"],
      });

      const printerInfo = {
        type: "bluetooth",
        name: device.name || "Impresora Bluetooth",
        manufacturer: "Desconocido",
        device_id: device.id,
      };

      addPrinterToList(printerInfo);
    } catch (error) {
      console.error("Error al agregar impresora Bluetooth:", error);
      setError(
        "No se pudo conectar con la impresora Bluetooth. Asegúrese de que el Bluetooth esté activado."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const addPrinterToList = async (printerInfo) => {
    const exists = printers?.some((p) => p.device_id === printerInfo.device_id);
    if (!exists) {
      const updatedPrinters = [...printers, printerInfo];
      setPrinters(updatedPrinters);
      await insert(printerInfo);
      localStorage.setItem("printers", JSON.stringify(updatedPrinters));
    }
  };

  // const selectPrinter = (printer) => {
  //   setSelectedPrinter(printer);
  //   localStorage.setItem("selectedPrinter", JSON.stringify(printer));
  // };

  // const removePrinter = (printerId) => {
  //   const updatedPrinters = printers.filter((p) => p.id !== printerId);
  //   setPrinters(updatedPrinters);
  //   localStorage.setItem("printers", JSON.stringify(updatedPrinters));

  //   if (selectedPrinter?.id === printerId) {
  //     setSelectedPrinter(null);
  //     localStorage.removeItem("selectedPrinter");
  //   }
  // };

  // const getConnectionIcon = (type) => {
  //   return type === "usb" ? "🔌" : "📶";
  // };

  return (
    <Row>
      <Col>
        <Card>
          <Card.Header>
            <Card.Title as="h4">Configuración Impresoras</Card.Title>
          </Card.Header>
          <Card.Body className="px-3">
            <Tabs defaultActiveKey="printers" className="px-20">
              <Tab eventKey="printers" title="Impresoras Configuradas">
                <hr />
                {error && (
                  <Alert
                    variant="danger"
                    onClose={() => setError(null)}
                    dismissible
                  >
                    {error}
                  </Alert>
                )}
                {printers.length > 0 ? (
                  <GenericTable
                    columns={columns}
                    data={printers}
                    // doubleClic={() => selectPrinter()}
                  />
                ) : (
                  ""
                )}
              </Tab>
            </Tabs>
          </Card.Body>
          <Card.Footer>
            <ButtonGroup>
              <Button
                onClick={addUSBPrinter}
                variant="primary"
                disabled={isLoading}
              >
                <b className="text-white">
                  {isLoading ? "Conectando..." : "Agregar USB"}
                </b>
              </Button>
              <Button
                onClick={addBluetoothPrinter}
                variant="info"
                disabled={isLoading}
                className="mx-2"
              >
                <b className="text-white">
                  {isLoading ? "Conectando..." : "Agregar Bluetooth"}
                </b>
              </Button>
            </ButtonGroup>
          </Card.Footer>
        </Card>
        <Card className="mt-2">
          <Card.Header>
            <Card.Title as="h5">
              <Link
                to="#"
                onClick={() => setAccordionKey(accordionKey !== 1 ? 1 : 0)}
                aria-controls="drivers"
                aria-expanded={accordionKey === 1}
              >
                Drivers para Windows
              </Link>
            </Card.Title>
          </Card.Header>
          <Collapse in={accordionKey === 1}>
            <div id="drivers">
              <Card.Header>
                <Card.Title>Driver impresora térmica - </Card.Title>
                <Link
                  to="https://github.com/pbatard/libwdi/releases/download/v1.5.1/zadig-2.9.exe">
                  Descargar aquí
                </Link>
              </Card.Header>
              <Card.Body>
                <Card.Text>
                  Para que la aplicación pueda comunicarse directamente con tu
                  impresora térmica, es necesario usar un controlador especial
                  llamado <strong>WinUSB</strong>. Windows, por defecto, instala
                  un driver genérico que no permite esta comunicación. Con la
                  herramienta
                  <strong> Zadig</strong>, reemplazamos ese controlador por
                  WinUSB, lo que hace posible que la impresora funcione
                  correctamente con nuestra aplicación.
                </Card.Text>

                <Card.Text>
                  <strong>Pasos para la instalación:</strong>
                </Card.Text>
                <ol>
                  <li>Descarga Zadig desde el enlace de arriba.</li>
                  <li>
                    Ejecuta Zadig (no requiere instalación, es un programa
                    portable).
                  </li>
                  <li>
                    Conecta tu <strong>impresora térmica</strong> por USB.
                  </li>
                  <li>
                    En Zadig, selecciona tu impresora en la lista desplegable.
                    <br />
                    Si no aparece, activa la opción{" "}
                    <em>Options → List All Devices</em>.
                  </li>
                  <li>
                    En la columna de la derecha, asegúrate de que el controlador
                    sea <strong>WinUSB</strong>.
                  </li>
                  <li>
                    Haz clic en <em>Install Driver</em> (o{" "}
                    <em>Replace Driver</em> si ya hay otro instalado).
                  </li>
                  <li>Espera a que termine el proceso. ¡Listo! 🎉</li>
                </ol>

                <Card.Text>
                  <em>Nota de seguridad:</em> Zadig es una herramienta confiable
                  y ampliamente usada para instalar controladores USB.
                  Descárgala siempre desde la página oficial o desde este
                  enlace.
                </Card.Text>
              </Card.Body>
            </div>
          </Collapse>
        </Card>
      </Col>
    </Row>
  );
};

// const ModalPrinter = () => {
//   return (
//     <React.Fragment>
//       <Modal>
//         <Modal.Body>
//           <PrinterConfig />
//         </Modal.Body>
//       </Modal>
//     </React.Fragment>
//   );
// };

// const GeneralConfig = () => {

//   return (
//     <React.Fragment>
//       <PrinterConfig/>
//     </React.Fragment>
//   );
// };

export default PrinterConfig;
